import React, { useContext, useState } from 'react';
import classNames from 'classnames';

import { media } from 'context';
import Icon from 'ds/Icon';
import Layout from 'ds/Layout';
import Popover from 'ds/Popover';

import Clickable from './Clickable';
import Modal from './Modal';
import Text from './Text';

interface Props {
  onEmojiSelect: ({ emoji, messageId }: { emoji: string; messageId: number }) => void;
  messageId: number;
  hasEmojis: boolean;
}

const EMOJIS = [
  '👍',
  '👎',
  '😊',
  '🎉',
  '👏',
  '🙌',
  '🤔',
  '🤗',
  '🤘',
  '🤙',
  '🤚',
  '🤛',
  '🤜',
  '🤝',
  '🤞',
  '🤟',
  '🤣',
  '🤤',
  '🤥',
  '🤦',
  '🤧',
  '🤨',
  '🤩',
  '🤪',
  '🤫',
  '🤬',
  '🤭',
  '🤮',
  '🤯',
  '🤲'
];

const MessageEmojiSelector: React.FC<Props> = ({ onEmojiSelect, messageId, hasEmojis }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isMobile } = useContext(media);
  const button = (
    <Clickable
      onClick={() => setIsOpen(!isOpen)}
      style={{ borderRadius: 16 }}
      className={classNames('MessageEmojiSelector-button', { 'has-emojis': hasEmojis })}
    >
      <Layout display="inline-flex" paddingX={12} paddingY={4} borderRadius={16}>
        <Icon name="addReaction" size="sm" color="gray-700" />
      </Layout>
    </Clickable>
  );

  const options = (
    <Layout wrap>
      {EMOJIS.map(emoji => (
        <Clickable
          key={emoji}
          onClick={() => {
            onEmojiSelect({ emoji, messageId });
            setIsOpen(false);
          }}
          style={{ padding: 4, display: 'inline-flex' }}
        >
          <Text size="body-lg">{emoji}</Text>
        </Clickable>
      ))}
    </Layout>
  );

  if (isMobile) {
    return (
      <>
        <Modal
          isVisible={isOpen}
          onClose={() => setIsOpen(false)}
          bottomSheetGutterTop={300}
          showCloseButton={false}
          bottomSheetBackgroundColor="gray-50"
          bottomSheetIsRounded
        >
          <Layout padding={24}>{options}</Layout>
        </Modal>
        {button}
      </>
    );
  }

  return (
    <Layout
      __className={classNames('MessageEmojiSelector', { 'is-open': isOpen, 'is-hoverable': !hasEmojis })}
      display="inline-flex"
    >
      <Popover
        isVisible={isOpen}
        color="gray-50"
        popoverStyle={{ width: 296, padding: 8 }}
        offset={[18, 8]}
        placement="bottom-end"
        onClickOutside={() => setIsOpen(false)}
        containerStyle={{ display: 'inline-flex' }}
        content={options}
      >
        {button}
      </Popover>
    </Layout>
  );
};

export default MessageEmojiSelector;
